import React, { VFC } from 'react';

type TProps = {
  object: string;
  type: number;
  children: React.ReactElement;
};

/**
 * !see https://www.figma.com/design/C4gTbCbLEmoxo7sSCK3AJn/MATCHBOX_UI?node-id=14296-131659&t=jXKtTOpR8EkqT8ob-4
 */
export const ConfirmationModal: VFC<TProps> = ({ object, type, children }) => {
  let title;
  let content;

  switch (type) {
    case 1:
      title = `MATCHBOXの入力代行が完了しました！\nまだ反映情報は確定されていません。\n${object}を確認の上、確定させてください。`;
      content =
        'MATCHBOX事務局が入力代行した内容を確認し、MATCHBOXへ反映を行ってください。\n情報を編集することも可能です。';
      break;
    case 2:
      title = '反映を確定してもよろしいですか？';
      content =
        '反映を確定すると、情報は上書きされます。\n内容に修正が必要な場合は、ご自身で編集・確認を行った上で反映を確定してください。';
      break;
    case 3:
      (title = `入力代行の反映が完了しました！\n続けて、${
        object == '履歴書' ? '職務経歴書' : '履歴書'
      }の内容も確認が必要です。`),
        (content =
          'MATCHBOX事務局が入力代行した内容を確認し、MATCHBOXへ反映を行ってください。\n情報を編集することも可能です。');
      break;
    case 4:
      title = '入力代行の反映が完了しました！';
      content =
        'おつかれさまでした！\n登録情報を見た企業からオファーがもらえる「オファー機能」へ登録しておきましょう。';
      break;
    case 5:
      title = '入力代行の反映が完了しました！';
      content =
        'おつかれさまでした！\n登録した情報はマイページからいつでも確認することができます。';
      break;
    case 6:
      title = 'これまで入力した内容をすべてリセットします。';
      content = '';
      break;
  }

  return (
    <div className="w-624 py-80 px-40 sm:w-5/6 sm:py-40 sm:px-0 sm:mx-auto">
      <p className="text-16_28 font-bold whitespace-pre-wrap">{title}</p>
      <p className="mt-8 text-12_20 whitespace-pre-wrap">{content}</p>
      {children}
    </div>
  );
};
